import { profile } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useAllTeachers = (params) => {
	return useQuery({
			queryKey: ['teachers', params],
			queryFn: () => profile.getAllTeachers(params),
			select: (data) => data.data
	})
}